import React from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { Tooltip } from "./Tooltip";
import { nFormatter } from "../../services";
import { TooltipContent } from "./TooltipContent";

const useStyles = makeStyles((theme) => ({
  leftRightXAxis: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& > p": {
      fontSize: 12,
      fontWeight: "bold",
    },
  },
}));

export const StackedAreaChart = ({
  data,
  areas,
  height,
  CustomTooltipContent,
  unit,
  onlyLeftRightXAxis,
  hideXAxis,
  hideYAxis,
  hideSumOnToolTip,
  yAxisDy,
  yAxisDx,
  yAxisWidth,
  xAxisPadding,
}) => {
  const classes = useStyles();

  return (
    <>
      <ResponsiveContainer width="100%" height={height || 220}>
        <AreaChart data={data}>
          <XAxis dataKey="x" tickLine={false} hide={hideXAxis} padding={xAxisPadding}/>
          <YAxis
            hide={hideYAxis}
            tickLine={false}
            axisLine={false}
            dy={yAxisDy}
            dx={yAxisDx}
            width={yAxisWidth}
            tickFormatter={nFormatter}
          />
          <Tooltip
            chartData={data}
            content={
              CustomTooltipContent ? (
                <CustomTooltipContent />
              ) : (
                <TooltipContent hideSum={hideSumOnToolTip} />
              )
            }
          />
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          {areas.map((area, i) => (
            <Area
              key={i}
              type="monotone"
              dataKey={area.key}
              stackId="1"
              stroke={area.stroke || area.fill}
              fill={area.fill}
              strokeWidth={2}
              unit={unit}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>

      {onlyLeftRightXAxis && (
        <Grid
          className={classes.leftRightXAxis}
          container
          justifyContent="space-between"
        >
          <Typography>{data[0].x}</Typography>
          <Typography>{data[data.length - 1].x}</Typography>
        </Grid>
      )}
    </>
  );
};

StackedAreaChart.defaultProps = {
  hideYAxis: false,
  hideXAxis: false,
  yAxisDx: 0,
  yAxisDy: 0,
  yAxisWidth: 30,
  xAxisPadding: {}
}
